class ProductBlockUpsells extends HTMLElement {
  constructor() {
    super();
  }

  onUpsellClickHandle(clickedUpsell) {
    const isActive = clickedUpsell.hasAttribute('active');

    this.upsellCards = this.parentElement.querySelectorAll('product-upsell-card');
    this.upsellCards.forEach(upsellCard => {
      upsellCard.removeAttribute('active');
    })

    isActive ? this.deactivateUpsell(clickedUpsell) : this.activateUpsell(clickedUpsell);
  }

  activateUpsell(clickedUpsell) {
    clickedUpsell.setAttribute('active', '');
    this.parentElement.setAttribute('data-selected-quantity', clickedUpsell.getAttribute('data-quantity'));

    const selectedVariantId = clickedUpsell.querySelector('[name="variant_id"]').value;
    this.parentElement.setAttribute('data-selected-variant-id', selectedVariantId);
  }

  deactivateUpsell(clickedUpsell) {
    clickedUpsell.removeAttribute('active');
    this.parentElement.setAttribute('data-selected-quantity', '');
    this.parentElement.setAttribute('data-selected-variant-id', '');
  }
}

if (!customElements.get('product-block-upsells')) {
  customElements.define('product-block-upsells', ProductBlockUpsells);
}

class ProductUpsellCard extends ProductBlockUpsells {
  constructor() {
    super();

    this.form = this.querySelector('form');
  }

  connectedCallback() {
    this.addEventListener('click', () => {
      this.onUpsellClickHandle(this);
    });

    this.form?.addEventListener('change', this.onFormChange.bind(this));
  }

  onFormChange() {
    const selectedVariantId = this.querySelector('[name="variant_id"]').value;
    this.parentElement.setAttribute('data-selected-variant-id', selectedVariantId);
    this.activateUpsell(this);
  }

  setSelectedVariantId() {
    this.parentElement?.setAttribute('data-selected-variant-id', '555555');
  }

  setSelectedQuantity() {
    this.parentElement?.setAttribute('data-selected-quantity', '5');
  }
}

if (!customElements.get('product-upsell-card')) {
  customElements.define('product-upsell-card', ProductUpsellCard);
}